export default [
  {
    color: '#ffc971',
    textColor: '#ff9505',
    label: 'Processando',
    value: 'PROCESSANDO',
  },
  {
    color: '#95d5b2',
    textColor: '#40916c',
    label: 'Finalizado',
    value: 'FINALIZADO',
  },
  {
    color: '#ff8fa3',
    textColor: '#c9184a',
    label: 'Erro',
    value: 'ERRO',
  },
];
